import React from 'react'

const IconTextThird = ({ image, imageAtl, header, text }) => (
  <div className="column is-one-third-desktop is-12-tablet has-text-centered-tablet u-margintop-medium-mobile">
    <img
      className="small-icon aligned-bottom-tablet"
      src={image}
      alt={imageAtl}
    />
    <div className="column u-padding-none-mobile">
      <h3 className="title">{header}</h3>
      <p>{text}</p>
    </div>
  </div>
)

export default IconTextThird
